import io from "socket.io-client";
import Vue from "vue";
import store from "./store";
import router from "./router";

let connectErrorToast = {};
let connectErrorShown = false;

// Prod'da aynı origin kullanacağız, istersen env ile override edebilirsin
const wsUri =
  process.env.NODE_ENV === "development"
    ? undefined
    : process.env.VUE_APP_WEBSOCKET_URI || undefined;

const BASE = process.env.VUE_APP_BASE_PATH
  ? process.env.VUE_APP_BASE_PATH.replace(/\/$/, "")
  : "";

// ✅ DOĞRU ÇAĞRI: io(uri, options)
const socket = io(wsUri, {
  path: BASE ? `${BASE}/socket.io` : "/socket.io",
  transports: ["websocket", "polling"],
  withCredentials: true,
});

const isPublicRoute = () => {
  try {
    return Boolean(
      router.currentRoute &&
        router.currentRoute.meta &&
        router.currentRoute.meta.public
    );
  } catch (e) {
    return false;
  }
};

const handleLogout = () => {
  store.commit("isConnected", false);

  // ✅ PUBLIC sayfadaysak login'e atma!
  if (isPublicRoute()) return;

  if (router.currentRoute.name !== "login") {
    router.push({ name: "login" });
  }
};

// (İstersen event adı connect_error da olabilir ama 404 bununla alakalı değil)
socket.on("connect_error", (err) => {
  // ✅ Public sayfada sessiz kal
  if (isPublicRoute()) return;

  if (!connectErrorShown) {
    connectErrorToast = Vue.prototype.$toast.error(err.message, {
      duration: 0,
    });
    connectErrorShown = true;
    handleLogout();
  }
});

socket.on("connect", () => {
  if (connectErrorShown) {
    connectErrorToast.dismiss();
    Vue.prototype.$toast.success("Reconnected");
    connectErrorShown = false;
  }
});

socket.on("disconnect", handleLogout);

export default socket;
